import React from "react";
import { useGlobalContext } from "../context";
import Cocktail from "./Cocktail";

const FavoriteCocktails = () => {
  const { cocktails, tempCocktails } = useGlobalContext();

  const getLocalStorage = () => {
    let cocktails = localStorage.getItem("favorites");
    if (cocktails) {
      return (cocktails = JSON.parse(localStorage.getItem("favorites")));
    } else {
      return [];
    }
  };

  if (getLocalStorage().length < 1) {
    return (
      <div className="cocktailList">
        <h1 className="title">Your favorite cocktails</h1>
        <h2 className="noMatch">
          You currently do not have any favorite cocktails!
        </h2>
      </div>
    );
  }
  return (
    <div className="cocktailList">
      <h1 className="title">Your favorite cocktails</h1>
      <div className="cocktails">
        {getLocalStorage().map((item) => {
          return <Cocktail key={item.id} {...item} />;
        })}
      </div>
    </div>
  );

  // const { tempCocktails } = useGlobalContext();

  // const newCocktails = tempCocktails
  //   .map((item) => {
  //     return item;
  //   })
  //   .filter((item) => {
  //     if (item.favorite === true) {
  //       return item;
  //     }
  //   });

  // if (newCocktails.length === 0) {
  //   return (
  //     <div className="cocktailList">
  //       <h1 className="title">Your favorite cocktails</h1>
  //       <h2 className="noMatch">
  //         You currently do not have any favorite cocktails
  //       </h2>
  //     </div>
  //   );
  // }
  // return (
  //   <div className="cocktailList">
  //     <h1 className="title">Your favorite cocktails</h1>
  //     <div className="cocktails">
  //       {tempCocktails.map((item) => {
  //         if (item.favorite === true) {
  //           return <Cocktail key={item.id} {...item} />;
  //         }
  //       })}
  //     </div>
  //   </div>
  // );
};

export default FavoriteCocktails;
